class NewsletterPopup extends HTMLElement {
    connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.delay = parseInt(this.dataset.delay, 10) || 0;
        this.expiry = parseInt(this.dataset.expire, 10) || 1;
        this.onBodyClick = (event) => {
            if (event.target.closest('[data-open-newsletter-popup]')) {
                event.preventDefault();
                this.open();
            } else if (this.isOpen && !this.contains(event.target)) this.close();
        };
        this.onKey = (event) => {
            if (!this.isOpen) return;
            if (event.key === 'Escape') { event.preventDefault(); this.close(); }
            if (event.key !== 'Tab') return;
            const items = Array.from(this.querySelectorAll('button, input:not([type="hidden"]), a[href]')).filter((item) => !item.disabled && item.getClientRects().length);
            const first = items[0], last = items[items.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        };
        this.querySelectorAll('[data-close-newsletter-popup]').forEach((button) => button.addEventListener('click', (event) => { event.preventDefault(); this.close(); }));
        document.body.addEventListener('click', this.onBodyClick);
        document.addEventListener('keydown', this.onKey);
        const popupPreview = new URLSearchParams(location.search).get('popup_preview');
        const draftPreview = this.dataset.draftPopupPreview === 'true' && ['1', 'success'].includes(popupPreview);
        if (draftPreview && popupPreview === 'success') {
            this.querySelector('[data-signup-reward]').hidden = false;
            this.querySelectorAll('.pinksand-signup-email, button.pinksand-signup-submit').forEach((item) => item.hidden = true);
        }
        const hasResult = this.querySelector('[data-popup-result]');
        if (draftPreview || hasResult || !this.getCookie('newsletter-popup')) {
            this.timer = setTimeout(() => this.open(), draftPreview || hasResult ? 1000 : this.delay);
        }
    }
    open() {
        if (this.isOpen) return;
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        document.body.classList.add('newsletter-show', 'show-newsletter-image');
        this.isOpen = true;
        this.querySelector('input[type="email"], [data-close-newsletter-popup]')?.focus({preventScroll:true});
    }
    close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        const expiry = new Date(Date.now() + this.expiry * 86400000).toUTCString();
        document.cookie = 'newsletter-popup=closed;expires=' + expiry + ';path=/;SameSite=Lax';
        document.body.classList.remove('newsletter-show', 'show-newsletter-image');
        document.body.style.overflow = this.previousOverflow || '';
        this.previousFocus?.focus({preventScroll:true});
    }
    getCookie(name) {
        const row = document.cookie.split(';').map((item) => item.trim()).find((item) => item.startsWith(name + '='));
        return row ? row.slice(name.length + 1) : '';
    }
    disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.isOpen) this.close();
        document.body.removeEventListener('click', this.onBodyClick);
        document.removeEventListener('keydown', this.onKey);
    }
}
if (!customElements.get('newsletter-popup')) customElements.define('newsletter-popup', NewsletterPopup);
